export const GET_EVENTS = 'GET_APP_EVENTS';
export const SET_EVENTS = 'SET_APP_EVENTS';
export const GET_EVENT_BY_SLUG = 'GET_APP_EVENT_BY_SLUG';
export const GET_EVENT_BY_ID = 'GET_APP_EVENT_BY_ID';
export const UPDATE_EVENT = 'UPDATE_APP_EVENT';
export const SET_ACTIVE_EVENT = 'SET_ACTIVE_APP_EVENT';
export const CREATE_EVENT = 'CREATE_EVENT';
